"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ThemeDivider } from "@/components/terra/component/ThemeDivider/ThemeDivider";
import { LayoutBlocks } from "@/components/terra/layouts/LayoutBlocks/LayoutBlocks";
import { LayoutItemizedList } from "@/components/terra/layouts/LayoutItemizedList/LayoutItemizedList";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { handleButtons } from "@/lib/utils";
export default function MXPLayoutItemizedList(props) {
  const $ = _c(48);
  const {
    value,
    index,
    divider,
    headerElement,
    lang
  } = props;
  const t0 = value.buttonsCollection?.items;
  let t1;
  if ($[0] !== lang || $[1] !== t0) {
    t1 = handleButtons(t0, true, lang);
    $[0] = lang;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const buttons = t1;
  let itemizedListItems;
  if ($[3] !== lang || $[4] !== value.listItemsCollection?.items) {
    itemizedListItems = [];
    (value.listItemsCollection?.items ?? []).forEach(item => {
      if (!item) {
        return;
      }
      const buttonData = handleButtons([item.ctaLink], false, lang);
      itemizedListItems.push({
        iconMachineName: `mxp-icon-${(item.icon ?? "").toLowerCase().replace(/ /g, "-")}`,
        header: item.header,
        description: item.description,
        link: buttonData?.[0],
        destination: buttonData?.[0]?.destination
      });
    });
    $[3] = lang;
    $[4] = value.listItemsCollection?.items;
    $[5] = itemizedListItems;
  } else {
    itemizedListItems = $[5];
  }
  const dividerClasses = `section-divider-wrap ${value.theme}`;
  if (value?.variant === "Blocks - Icons Disabled" || value?.variant === "Blocks - Icons Enabled") {
    const t2 = value.eyebrow;
    const t3 = value.header;
    const t4 = value.subheader;
    const t5 = value?.description?.json;
    let t6;
    if ($[6] !== t5) {
      t6 = documentToHtmlString(t5);
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const t7 = value.variant === "Blocks - Icons Disabled" ? false : true;
    const t8 = value.isHeaderBig || false;
    let t9;
    if ($[8] !== buttons || $[9] !== headerElement || $[10] !== itemizedListItems || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== value.eyebrow || $[15] !== value.header || $[16] !== value.subheader || $[17] !== value.theme) {
      t9 = <LayoutBlocks eyebrow={t2} header={t3} subheader={t4} description={t6} presetTheme={value.theme} iconTextItems={itemizedListItems} buttons={buttons} isWrapped={true} isIconVisible={t7} isHeaderBig={t8} headerElement={headerElement} />;
      $[8] = buttons;
      $[9] = headerElement;
      $[10] = itemizedListItems;
      $[11] = t6;
      $[12] = t7;
      $[13] = t8;
      $[14] = value.eyebrow;
      $[15] = value.header;
      $[16] = value.subheader;
      $[17] = value.theme;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== divider || $[20] !== dividerClasses || $[21] !== value.theme) {
      t10 = divider && <div className={dividerClasses}><ThemeDivider currentTheme={value.theme} /></div>;
      $[19] = divider;
      $[20] = dividerClasses;
      $[21] = value.theme;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    if ($[23] !== index || $[24] !== t10 || $[25] !== t9) {
      t11 = <React.Fragment key={index}>{t9}{t10}</React.Fragment>;
      $[23] = index;
      $[24] = t10;
      $[25] = t9;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    return t11;
  }
  const t2 = value.eyebrow;
  const t3 = value.header;
  const t4 = value.subheader;
  const t5 = value?.description?.json;
  let t6;
  if ($[27] !== t5) {
    t6 = documentToHtmlString(t5);
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  const t7 = value.variant !== "List - Icons Disabled";
  const t8 = value.isHeaderBig || false;
  let t9;
  if ($[29] !== buttons || $[30] !== headerElement || $[31] !== itemizedListItems || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== value.eyebrow || $[36] !== value.header || $[37] !== value.subheader || $[38] !== value.theme) {
    t9 = <LayoutItemizedList eyebrow={t2} header={t3} subheader={t4} description={t6} presetTheme={value.theme} iconTextItems={itemizedListItems} buttons={buttons} isWrapped={true} isIconVisible={t7} isHeaderBig={t8} headerElement={headerElement} />;
    $[29] = buttons;
    $[30] = headerElement;
    $[31] = itemizedListItems;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = value.eyebrow;
    $[36] = value.header;
    $[37] = value.subheader;
    $[38] = value.theme;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== divider || $[41] !== dividerClasses || $[42] !== value.theme) {
    t10 = divider && <div className={dividerClasses}><ThemeDivider currentTheme={value.theme} /></div>;
    $[40] = divider;
    $[41] = dividerClasses;
    $[42] = value.theme;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  let t11;
  if ($[44] !== index || $[45] !== t10 || $[46] !== t9) {
    t11 = <React.Fragment key={index}>{t9}{t10}</React.Fragment>;
    $[44] = index;
    $[45] = t10;
    $[46] = t9;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  return t11;
}